import { tEnum } from '@components/i18n';

export enum InsuranceTypes {
  Car = 'car',
  Health = 'health',
  PersonalAccident = 'personal_accident',
  Cancer = 'cancer',
  Fire = 'fire',
  Life = 'life',
}

export enum InsuranceTypesEnum {
  HLTH = 'hlth',
  PA = 'pa',
  AUTO_PV = 'auto_pv',
  AUTO_CV = 'auto_cv',
  AUTO_M = 'auto_m',
  LIFE = 'life',
  TRAV = 'trav',
  PROP = 'prop',
  FIRE = 'fire',
  ENGI = 'engi',
  MAR = 'mar',
  CRIT = 'crit',
  LIAB = 'liab',
  MICRO = 'micro',
  AGRI = 'agri'
}

export const tInsuranceType = (type: InsuranceTypes) => tEnum('insuranceTypes', type);
export const tInsuranceTypeName = (type: InsuranceTypes) => tEnum('insuranceTypeNames', type);

export const tInsuranceTypeEnum = (type: InsuranceTypesEnum) => tEnum('insuranceTypesEnum', type);
